<template>
  <div id="app">
    <router-view :key="Math.random()"/>
  </div>
</template>

<script>
import jwt_decode from "jwt-decode";
const rate= window.innerWidth/1920;
export default {
  name: "app",
    metaInfo: {
       meta: [
        { name:'viewport', content:
        `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
      ]
    },
  created() {
    if (localStorage.eleTokenWrd001) {
      const decode = jwt_decode(localStorage.eleTokenWrd001);
      this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
      this.$store.dispatch("setUser", decode);
    }
  },
  methods: {
    isEmpty(value) {
      return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
      );
    }
  }
};
</script>


<style>
</style>
